<template>
  <div class="food-graphics-container">
    <h2 v-if="!loading">
      Materia prima: {{ foodName }}<span v-if="foodDensityDisplay" class="food-density"> · Densidade: {{ foodDensityDisplay }}</span>
    </h2>
    <div class="chart-status-wrapper">
      <transition name="fade-slide">
        <div v-if="isLoading" class="loading-inline-message">
          Carregando dados...
        </div>
      </transition>
      <div class="chart-area" :class="{ 'is-loading': isLoading }">
        <transition name="fade-overlay">
          <div v-if="isLoading" class="chart-loading-overlay" aria-hidden="true"></div>
        </transition>
        <div class="chart-content">
          <BarChartComponent :foodProfiles="{ [foodType]: foodData }" :foodName="foodName" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChartComponent from './BarChartComponent.vue'

export default {
  name: 'AccFoodGraphics',
  components: {
    BarChartComponent
  },
  props: {
    foodType: {
      type: String,
      required: true
    },
    foodData: {
      type: Array,
      required: true
    },
    foodsByCompany: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedFood() {
      return this.foodsByCompany.find((item) => String(item?.pk) === String(this.foodType)) || null
    },
    foodName() {
      return this.selectedFood?.name || `ID ${this.foodType}`
    },
    foodDensityDisplay() {
      const density = Number(this.selectedFood?.density)
      if (!Number.isFinite(density) || density <= 0) return ''
      const formatted = density.toLocaleString('pt-BR', {
        minimumFractionDigits: density % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      })
      return `${formatted} kg/m³`
    }
  },
}
</script>

<style scoped>
.food-graphics-container {
  margin: 20px 0;
  padding: 15px;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.5rem;
}

.food-density {
  color: #5b8a34;
  font-size: 0.95rem;
  font-weight: 500;
  margin-left: 4px;
}

.loading-inline-message {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  font-weight: 600;
  color: #3f9b34;
  letter-spacing: 0.2px;
  animation: subtle-pulse 1.3s ease-in-out infinite;
  z-index: 2;
  pointer-events: none;
}

.chart-status-wrapper {
  position: relative;
}

.chart-area {
  position: relative;
  overflow: hidden;
  border-radius: 6px;
}

.chart-content {
  transition: filter 0.35s ease, transform 0.35s ease, opacity 0.35s ease;
}

.chart-area.is-loading .chart-content {
  filter: blur(0.35px) saturate(0.99);
  transform: scale(0.9995);
  opacity: 0.98;
}

.chart-loading-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(120, 184, 67, 0.12) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  background-size: 220% 100%;
  animation: chart-shimmer 1.5s linear infinite;
  pointer-events: none;
  z-index: 1;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-4px);
}

.fade-overlay-enter-active,
.fade-overlay-leave-active {
  transition: opacity 0.25s ease;
}

.fade-overlay-enter,
.fade-overlay-leave-to {
  opacity: 0;
}

@keyframes subtle-pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

@keyframes chart-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -20% 0;
  }
}
</style>
